import React from 'react';
import { Class, Law, Office, Questions, Notes } from '../../../../assets/img/svg/icons';
import { DetailInfo, Traced } from '../../../../assets/img/svg/details';

const Card: React.FC<{ title: string; text: string; icon: React.ReactNode, number: number }> = ({ title, text, icon, number }) => {
    return (
        <div className="group bg-white rounded-lg pb-8 2xl:pb-10 pt-4 2xl:pt-6 transition-all duration-200 hover:bg-main-pink hover:text-white hover:-translate-y-2">
            <div className="flex items-center justify-end text-2xl text-main-pink font-semibold pr-2 pb-4 transition-all duration-200 group-hover:text-white">
                {number > 1 ? <Traced className='w-full'/> : ''}
                {number}
            </div>
            <div className='flex flex-col items-center space-y-4 px-8 2xl:px-10'>
                <span className="transition-all duration-200 fill-main-pink group-hover:fill-white">
                    {icon}
                </span>
                
                <h3 className="font-semibold text-center">{title}</h3>
                <p className="text-center text-sm 2xl:text-base">{text}</p>
            </div>
        </div>
    );
};

const InfoSection: React.FC = () => {
    return (
        <section className='py-8 relative'>
            <div className="absolute -z-20 top-20 h-[calc(100%+200px)] w-dvw">
                <DetailInfo className='object-cover h-full w-full scale-150 -translate-y-44' />
            </div>

            <h2 className="text-center font-semibold text-2xl mb-10 text-balance">
                Por que participar dos nossos eventos?
            </h2>

            <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-2 max-w-[1920px] mx-auto">
                <Card 
                    icon={<Class className="w-12 h-12 object-contain" />} 
                    title="As melhores faculdades e universidades" 
                    text="Conheça as principais instituições de ensino superior do país, públicas e privadas. Amplie suas possibilidades e descubra novos caminhos para chegar onde você quer." 
                    number={1}
                />

                <Card 
                    icon={<Notes className="w-12 h-12 object-contain" />} 
                    title="Palestras que inspiram" 
                    text="Profissionais renomados falam sobre vestibular, profissões e carreira. Conteúdo exclusivo também para pais e educadores." 
                    number={2}
                />

                <Card 
                    icon={<Office className="w-12 h-12 object-contain" />} 
                    title="Tira-dúvidas com especialistas" 
                    text="Converse com profissionais de diversas áreas e tire dúvidas sobre o dia a dia da profissão. Encontre respostas que te ajudam a enxergar com clareza seus próximos passos." 
                    number={3}
                />

                <Card 
                    icon={<Questions className="w-12 h-12 object-contain" />} 
                    title="Oficinas práticas" 
                    text="Vivencie diferentes cursos e profissões com atividades práticas oferecidas por universidades. Descubra, na prática, o que desperta seu interesse e te motiva." 
                    number={4}
                />

                <Card 
                    icon={<Law className="w-12 h-12 object-contain" />} 
                    title="Teste profissional" 
                    text="Teste exclusivo e gratuito para descobrir as áreas que mais combinam com o seu perfil. Autoconhecimento para fazer escolhas com mais segurança." 
                    number={5}
                />
            </div>
        </section>
    );
};

export default InfoSection;
